"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  v: '5.1.18',
  fr: 30,
  ip: 0,
  op: 41,
  w: 1080,
  h: 1080,
  nm: 'Loader comp',
  ddd: 0,
  assets: [],
  layers: [{
    ddd: 0,
    ind: 1,
    ty: 4,
    nm: 'Shape Layer 1',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [540, 540, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        d: 1,
        ty: 'el',
        s: {
          a: 0,
          k: [678, 678],
          ix: 2
        },
        p: {
          a: 0,
          k: [0, 34],
          ix: 3
        },
        nm: 'Ellipse Path 1',
        mn: 'ADBE Vector Shape - Ellipse',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 1,
          k: [{
            i: {
              x: [0.667],
              y: [1]
            },
            o: {
              x: [0.333],
              y: [0]
            },
            n: ['0p667_1_0p333_0'],
            t: -1,
            s: [0],
            e: [100]
          }, {
            t: 29
          }],
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0.667],
              y: [1]
            },
            o: {
              x: [0.333],
              y: [0]
            },
            n: ['0p667_1_0p333_0'],
            t: 6,
            s: [0],
            e: [100]
          }, {
            t: 36
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 2,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [0, 0.682352941176, 0.721568627451, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 59,
          ix: 5
        },
        lc: 2,
        lj: 2,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [-7, 22],
          ix: 2
        },
        a: {
          a: 0,
          k: [-13.96, 41.879],
          ix: 1
        },
        s: {
          a: 0,
          k: [85.962, 85.962],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Ellipse 1',
      np: 4,
      cix: 2,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        d: 1,
        ty: 'el',
        s: {
          a: 0,
          k: [678, 678],
          ix: 2
        },
        p: {
          a: 0,
          k: [0, 0],
          ix: 3
        },
        nm: 'Ellipse Path 1',
        mn: 'ADBE Vector Shape - Ellipse',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 1,
          k: [{
            i: {
              x: [0.667],
              y: [1]
            },
            o: {
              x: [0.333],
              y: [0]
            },
            n: ['0p667_1_0p333_0'],
            t: 3,
            s: [0],
            e: [100]
          }, {
            t: 32
          }],
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0.667],
              y: [1]
            },
            o: {
              x: [0.333],
              y: [0]
            },
            n: ['0p667_1_0p333_0'],
            t: 11,
            s: [0],
            e: [100]
          }, {
            t: 39
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 2,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [0.972549019608, 0.6, 0.109803921569, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 59,
          ix: 5
        },
        lc: 2,
        lj: 2,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [6, 15],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [85.962, 85.962],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Ellipse 2',
      np: 4,
      cix: 2,
      ix: 2,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        d: 1,
        ty: 'el',
        s: {
          a: 0,
          k: [678, 678],
          ix: 2
        },
        p: {
          a: 0,
          k: [0, 0],
          ix: 3
        },
        nm: 'Ellipse Path 1',
        mn: 'ADBE Vector Shape - Ellipse',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 1,
          k: [{
            i: {
              x: [0.667],
              y: [1]
            },
            o: {
              x: [0.333],
              y: [0]
            },
            n: ['0p667_1_0p333_0'],
            t: 9,
            s: [0],
            e: [100]
          }, {
            t: 34
          }],
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0.667],
              y: [1]
            },
            o: {
              x: [0.333],
              y: [0]
            },
            n: ['0p667_1_0p333_0'],
            t: 16,
            s: [0],
            e: [100]
          }, {
            t: 42
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 2,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [0.945098039216, 0.360784313725, 0.243137254902, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 59,
          ix: 5
        },
        lc: 2,
        lj: 2,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [6, 15],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [85.962, 85.962],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Ellipse 3',
      np: 4,
      cix: 2,
      ix: 3,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 0,
    op: 41,
    st: -1,
    bm: 0
  }],
  markers: []
};
exports["default"] = _default;